<h1>Nuevo Presupuesto</h1>
<div class="mat-elevation-z4 divmarco">
  <form [formGroup]="presupuestoForm" (ngSubmit)="onSubmit()" autocomplete="off">
    <h1>Datos Generales del Presupuesto</h1>
    <hr>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="align-items: normal !important;">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Indica una Empresa" appearance="outline"
          [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'" floatLabel="always">
          <mat-label>Empresa:</mat-label>
          <mat-select formControlName="nombreEmpresa" placeholder="Seleccione o agrega una opción">
            <mat-option *ngFor="let item of listEmpresas" [value]="item.id">{{item.value}}</mat-option>
          </mat-select>
          <mat-icon matSuffix>apartment</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="padding-top: 15px;">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Indica un título" appearance="outline"
          [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'"
          floatLabel="always">
          <mat-label>Título de Obra</mat-label>
          <mat-select formControlName="tituloObra" placeholder="Seleccione una opción">
            <mat-option *ngFor="let item of listTitulosObras" [value]="item.id">{{item.value}}</mat-option>
          </mat-select>
          <mat-icon matSuffix>work</mat-icon>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Indica el precio" appearance="outline"
          [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'"
          floatLabel="always">
          <mat-label>Capturar Precios</mat-label>
          <mat-select formControlName="capturaPrecios" placeholder="Seleccione una opción">
            <mat-option *ngFor="let item of listCapturaPrecios" [value]="item.id">{{item.value}}</mat-option>
          </mat-select>
          <mat-icon matSuffix>payments</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="padding-top: 15px;">
      <mat-form-field fxLayout="column" fxFlex="grow" fxFlex.xs="grow" fxFlex.sm="grow" fxFlex.md="grow"
        hintLabel="Ingrese nombre presupuesto" appearance="outline" floatLabel="always" [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'">
          <mat-label>Nombre del Presupuesto:</mat-label>
          <input matInput formControlName="nombrePresupuesto" name="nombrePresupuesto" minlength="4" maxlength="250"
            autocomplete="off" required>
          <mat-icon matSuffix>description</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['nombrePresupuesto'].hasError('required')">Nombre presupuesto es
            requerido.</mat-error>
          <mat-error *ngIf="presupuestoForm.controls['nombrePresupuesto'].hasError('minlength')">Nombre presupuesto debe
            ser mínimo 4 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['nombrePresupuesto'].hasError('maxlength')">Nombre presupuesto debe
            ser máximo 250 caracteres.
          </mat-error>
        </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="padding-top: 15px;">
        <mat-form-field fxLayout="column" fxFlex="grow" fxFlex.xs="grow" fxFlex.sm="grow" fxFlex.md="grow" appearance="outline"
          floatLabel="always" hintLabel="Ingrese descripción presupuesto" [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'">
          <mat-label>Descripción:</mat-label>
          <textarea matInput formControlName="descripcionPresupuesto" name="descripcionPresupuesto" cdkTextareaAutosize
            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="1" cdkAutosizeMaxRows="5"></textarea>
            <mat-error *ngIf="presupuestoForm.controls['descripcionPresupuesto'].hasError('minlength')">Descripción
            presupuesto debe ser mínimo 10 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['descripcionPresupuesto'].hasError('maxlength')">Descripción
            presupuesto debe ser máximo 250 caracteres.
          </mat-error>
        </mat-form-field>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="padding-top: 15px;">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese Ubicación" appearance="outline" floatLabel="always"
        [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'">
          <mat-label>Ubicación, Condiciones, Validez:</mat-label>
          <input matInput formControlName="ubicacionCondicionesValidez" name="ubicacionCondicionesValidez" minlength="4"
            maxlength="100" autocomplete="off">
          <mat-icon matSuffix>location_on</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['ubicacionCondicionesValidez'].hasError('minlength')">Campo debe
            ser mínimo 4 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['ubicacionCondicionesValidez'].hasError('maxlength')">Campo debe
            ser máximo 100 caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese contratante del presupuesto" appearance="outline"
          floatLabel="always" [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'">
          <mat-label>Contratante:</mat-label>
          <input matInput formControlName="contratante" name="contratante" minlength="4" maxlength="100"
            autocomplete="off" required>
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['contratante'].hasError('required')">Contratante es
            requerido.</mat-error>
          <mat-error *ngIf="presupuestoForm.controls['contratante'].hasError('minlength')">Contratante debe
            ser mínimo 4 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['contratante'].hasError('maxlength')">Contratante debe
            ser máximo 100 caracteres.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="padding-top: 15px;">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese el número de contrato" appearance="outline"
        [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'" floatLabel="always">
          <mat-label>Número de Contrato:</mat-label>
          <input matInput formControlName="numContrato" name="numContrato" minlength="4" maxlength="14" autocomplete="off">
          <mat-icon matSuffix>pin</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['numContrato'].hasError('minlength')">Contrato debe ser mínimo 4
            caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['numContrato'].hasError('maxlength')">Contrato debe ser máximo 14
            caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Seleccione fecha presupuesto" appearance="outline"
        [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'" floatLabel="always">
          <mat-label>Fecha del Presupuesto:</mat-label>
          <input matInput formControlName="fechaPresupuesto" [matDatepicker]="pickerStart" [min]="todayDate" readonly
            (click)="pickerStart.open()">
          <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart disabled="false"></mat-datepicker>
          <mat-error *ngIf="presupuestoForm.controls['fechaPresupuesto'].hasError('invalid')">Fecha presupuesto es
            inválida.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="padding-top: 15px;">
        <div>
          <mat-form-field fxLayout="column" hintLabel="Indica si aplica I.V.A" appearance="outline"
            [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'"
            floatLabel="always">
            <mat-label>Opción I.V.A.</mat-label>
            <mat-select formControlName="aplicarIva" placeholder="Seleccione una opción">
              <mat-option *ngFor="let item of listOpcionesIva" [value]="item.id">{{item.value}}</mat-option>
            </mat-select>
            <mat-icon matSuffix>percent</mat-icon>
            </mat-form-field>
            </div>
            <div>
              <mat-form-field fxLayout="column" hintLabel="Indica si reemplaza precios" appearance="outline"
                [ngClass]="classFlag ? 'input-width-275' : 'input-width-415'"
                floatLabel="always">
                <mat-label>Opción Reemplazar Precios</mat-label>
                <mat-select formControlName="reemplazarPrecios" placeholder="Seleccione una opción">
                  <mat-option *ngFor="let item of listReemplazarPrecios" [value]="item.id">{{item.value}}</mat-option>
                </mat-select>
                <mat-icon matSuffix>move_up</mat-icon>
              </mat-form-field>
      </div>
    </div>
    <br />
    <mat-label>Firma No 1:</mat-label>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten"
      style="border: 1px solid black !important; border-radius: 5px !important; padding-top: 20px !important; padding-bottom: 20px !important;">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese un nombre" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>Nombre:</mat-label>
          <input matInput formControlName="nombreFirmaUno" name="nombreFirmaUno" minlength="4" maxlength="20"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['nombreFirmaUno'].hasError('minlength')">Debe ser mínimo 4
            caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['nombreFirmaUno'].hasError('maxlength')">Debe ser máximo 20
            caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese descripción" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>Descripción:</mat-label>
          <input matInput formControlName="descripcionFirmaUno" name="descripcionFirmaUno" minlength="4" maxlength="20"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['descripcionFirmaUno'].hasError('minlength')">Debe debe ser
            mínimo 4 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['descripcionFirmaUno'].hasError('maxlength')">Debe ser
            máximo 20 caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese CIV o CI" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>CIV / CI:</mat-label>
          <input matInput formControlName="civFirmaUno" name="civFirmaUno" minlength="5" maxlength="10"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaUno'].hasError('pattern')">Debe ser solo
            números.</mat-error>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaUno'].hasError('minlength')">Debe ser mínimo 5
            caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaUno'].hasError('maxlength')">Debe ser máximo 10
            caracteres.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <br />
    <mat-label>Firma No 2:</mat-label>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten"
      style="border: 1px solid black !important; border-radius: 5px !important; padding-top: 20px !important; padding-bottom: 20px !important;">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese nombre" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>Nombre:</mat-label>
          <input matInput formControlName="nombreFirmaDos" name="nombreFirmaDos" minlength="4" maxlength="20"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['nombreFirmaDos'].hasError('minlength')">Debe ser mínimo 4
            caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['nombreFirmaDos'].hasError('maxlength')">Debe ser máximo 20
            caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese descripción" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>Descripción:</mat-label>
          <input matInput formControlName="descripcionFirmaDos" name="descripcionFirmaDos" minlength="4" maxlength="20"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['descripcionFirmaDos'].hasError('minlength')">Debe ser
            mínimo 4 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['descripcionFirmaDos'].hasError('maxlength')">Debe ser
            máximo 20 caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese CIV o CI" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>CIV / CI:</mat-label>
          <input matInput formControlName="civFirmaDos" name="civFirmaDos" minlength="5" maxlength="10"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaDos'].hasError('pattern')">Debe ser solo
            números.</mat-error>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaDos'].hasError('minlength')">Debe ser mínimo 5
            caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaDos'].hasError('maxlength')">Debe ser máximo 10
            caracteres.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <br />
    <mat-label>Firma No 3:</mat-label>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="border: 1px solid black !important; border-radius: 5px !important; padding: 20px;">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese nombre" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>Nombre:</mat-label>
          <input matInput formControlName="nombreFirmaTres" name="nombreFirmaTres" minlength="4" maxlength="20"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['nombreFirmaTres'].hasError('minlength')">Debe ser mínimo 4
            caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['nombreFirmaTres'].hasError('maxlength')">Debe ser máximo 20
            caracteres.</mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese descripción" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>Descripción:</mat-label>
          <input matInput formControlName="descripcionFirmaTres" name="descripcionFirmaTres" minlength="3"
            maxlength="20" autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['descripcionFirmaTres'].hasError('minlength')">Debe ser
            mínimo 4 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['descripcionFirmaTres'].hasError('maxlength')">Debe ser
            máximo 20 caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese CIV o CI" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>CIV / CI:</mat-label>
          <input matInput formControlName="civFirmaTres" name="civFirmaTres" minlength="5" maxlength="10"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaTres'].hasError('pattern')">Debe ser solo
            números.</mat-error>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaTres'].hasError('minlength')">Debe ser mínimo 5
            caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaTres'].hasError('maxlength')">Debe ser máximo 10
            caracteres.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <br />
    <mat-label>Firma No 4:</mat-label>
    <div fxLayout="row" fxLayoutAlign="space-around center" fxLayoutGap="20px" fxLayout.sm="column" fxLayout.xs="column"
      class="divconten" style="border: 1px solid black !important; border-radius: 5px !important; padding: 20px;">
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese nomobre" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>Nombre:</mat-label>
          <input matInput formControlName="nombreFirmaCuatro" name="nombreFirmaCuatro" minlength="4" maxlength="20"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['nombreFirmaCuatro'].hasError('minlength')">Debe ser mínimo
            4 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['nombreFirmaCuatro'].hasError('maxlength')">Debe ser máximo
            20 caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese descripción" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>Descripción:</mat-label>
          <input matInput formControlName="descripcionFirmaCuatro" name="descripcionFirmaCuatro" minlength="4"
            maxlength="20" autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['descripcionFirmaCuatro'].hasError('minlength')">Debe ser
            mínimo 4 caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['descripcionFirmaCuatro'].hasError('maxlength')">Debe ser
            máximo 20 caracteres.
          </mat-error>
        </mat-form-field>
      </div>
      <div>
        <mat-form-field fxLayout="column" hintLabel="Ingrese CIV o CI" appearance="outline" class="input-width-240"
          floatLabel="always">
          <mat-label>CIV / CI:</mat-label>
          <input matInput formControlName="civFirmaCuatro" name="civFirmaCuatro" minlength="5" maxlength="10"
            autocomplete="off">
          <mat-icon matSuffix>person</mat-icon>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaCuatro'].hasError('pattern')">Debe ser solo
            números.</mat-error>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaCuatro'].hasError('minlength')">Debe ser mínimo 5
            caracteres.
          </mat-error>
          <mat-error *ngIf="presupuestoForm.controls['civFirmaCuatro'].hasError('maxlength')">Debe ser máximo
            10 caracteres.
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" class="divconten">
      <p style="font-weight: bold;">(*) Estos campos son obligatorios.</p>
    </div>
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" fxLayout.sm="row" fxLayout.xs="column"
      class="divconten">
      <div fxLayout="column">
        <button mat-raised-button (click)="navigateMenu('presupuestos');" color="warn" type="button"
          class="align-center-middle">
          <span class="text-icon-space">Regresar a Home</span>
          <mat-icon>home</mat-icon>
        </button>
      </div>
      <div fxLayout="column">
        <button mat-raised-button color="primary" type="submit" [disabled]="disablebutton" class="align-center-middle">
          <span class="text-icon-space">Guardar Presupuesto</span>
          <mat-icon>data_saver_on</mat-icon>
        </button>
      </div>
    </div>
  </form>
</div>